export default __webpack_public_path__ + "static/media/icon_app_on.a73bf2f9.svg";